import React from 'react';
import { Box, Grid } from '@mui/material';
import About from './About';
import Skills, { Language, Skill } from './Skills';
import Experience, { Experiences } from './Experience';
import { AboutOnly } from '../api/aboutApi';


interface ResumeProps {
  isLoggedIn: boolean;
  skills: Skill[];
  languages: Language[];
  experiences: Experiences[];
  about: AboutOnly
}

const Resume: React.FC<ResumeProps> = ({ isLoggedIn, skills, languages, experiences, about }) => {
  // const isMobile = window.innerWidth <= 768; // Example way to check for mobile
  return (
    <Box
      sx={{
        backgroundColor: '#282c34',
        minHeight: '100vh',
        padding: 4,
      }}
    >
       <Grid container spacing={4}>
        {/* About Section */}
        <Grid item xs={12}>
          <About isLoggedIn={isLoggedIn} about={about}/>
        </Grid>

        {/* Skills and Experience Section */}
        <Grid container item spacing={4}>
          {/* Skills Section - 1/3 Width */}
          <Grid item xs={12} md={4}>
            <Skills isLoggedIn={isLoggedIn} userId={1} skills={skills} languages={languages}/>
          </Grid>

          {/* Experience Section - 2/3 Width */}
          <Grid item xs={12} md={8}>
            <Experience isLoggedIn={isLoggedIn} experiences={experiences} />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume;
